<template>
  <div v-if="isShow" id="MenuBreadcrumb" class="menu-box">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-if="!isFromEntrance" :to="{path:'/'}" replace>产品库</el-breadcrumb-item>
      <el-breadcrumb-item v-if="isFromEntrance" replace>产品库</el-breadcrumb-item>
      <el-breadcrumb-item class="bread-current-item">{{breadcrumbItemName}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import envCodes from '@/assets/js/envCodes'
export default {
  name: 'MenuBreadcrumb',
  data() {
    return {
      fanCode: envCodes.fanCode,
      pumpCode: envCodes.pumpCode,
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
      productClassificationMenu: 'classification/productClassificationMenu',
      isFromEntrance: 'isFromEntrance',
    }),
    isShow() {
      return this.$route.meta.showMenu
    },
    breadcrumbItemName() {
      const routeName = this.$route.name
      if (['Index', 'FanList', 'Products', 'PumpList', 'ProductList'].includes(routeName)) {
        let categoryCode = this.$route.params.categoryCode
        if (['Index', 'FanList', 'Products'].includes(routeName)) {
          categoryCode = this.fanCode
        } else if (routeName === 'PumpList') {
          categoryCode = this.pumpCode
        }
        const obj = this.productClassificationMenu.find((item) => item.code === categoryCode) || {}
        return obj.name
      } else {
        return this.$route.meta.title
      }
    }
  },
  created() {
    this.loadProductClassifications()
  },
  methods: {
    ...mapActions({
      loadProductClassifications: 'classification/loadProductClassifications'
    }),
  }
}
</script>

<style lang="less" scoped>
  .menu-box{
    padding: 6px 0;
    border-bottom: 1px solid @theme-border-color;
  }
</style>
